"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _star_with_circle_icon = _interopRequireDefault(require("./star_with_circle_icon"));
var _reactMotion = require("react-motion");
var _constants = require("@seedlang/constants");
var _reactTooltip = _interopRequireDefault(require("react-tooltip"));
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  cursor: ", ";\n  .star-with-circle-icon {\n    width: ", ";\n  }\n  margin: ", ";\n"])), function (props) {
  return props.cursor;
}, function (props) {
  return props.width;
}, function (props) {
  return props.margin;
});
var SelectedWrapper = _styled["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  transform: ", ";\n  .sparkle-icon-1 {\n    svg {\n      position: absolute;\n      z-index: 99;\n      width: 4px;\n    }\n  }\n"])), function (props) {
  return "scale(".concat(props.scale, ")");
});
var LearnedIcon = /*#__PURE__*/function (_React$Component) {
  function LearnedIcon() {
    _classCallCheck(this, LearnedIcon);
    return _callSuper(this, LearnedIcon, arguments);
  }
  _inherits(LearnedIcon, _React$Component);
  return _createClass(LearnedIcon, [{
    key: "render",
    value: function render() {
      var _this = this;
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        cursor: this.props.cursor,
        width: this.props.width,
        margin: this.props.margin
      }, /*#__PURE__*/_react["default"].createElement(_reactMotion.Motion, {
        style: {
          scale: (0, _reactMotion.spring)(this.props.selected ? 1 : 0, _reactMotion.presets.wobbly)
        }
      }, function (_ref) {
        var scale = _ref.scale;
        return /*#__PURE__*/_react["default"].createElement(SelectedWrapper, {
          scale: scale
        }, /*#__PURE__*/_react["default"].createElement(_star_with_circle_icon["default"], {
          onClick: _this.props.onClick,
          color: "#FFF",
          backgroundColor: _constants.Theme.green,
          width: _this.props.width
        }));
      }), /*#__PURE__*/_react["default"].createElement("div", {
        "data-tip": this.props.showTooltip,
        "data-for": this.props.id
      }, /*#__PURE__*/_react["default"].createElement(_star_with_circle_icon["default"], {
        onClick: this.props.onClick,
        color: "#FFF",
        backgroundColor: "#d8d8d8",
        width: this.props.width
      }), /*#__PURE__*/_react["default"].createElement(_reactTooltip["default"], {
        place: "top",
        type: "dark",
        effect: "solid",
        id: this.props.id,
        "class": "custom-tooltip"
      }, "Mark as Learned")));
    }
  }]);
}(_react["default"].Component);
LearnedIcon.defaultProps = {
  cursor: 'pointer'
};
var _default = exports["default"] = LearnedIcon;